import React, { useEffect } from "react";
import {
    getSchedulerOverviewProcessingState,
    getSortableRules,
} from "store/features/emailScheduler/overview/overview.selectors";
import { useDispatch, useSelector } from "react-redux";
import { fetchSchedulerOverviewConfigs } from "store/features/emailScheduler/overview/overview.actions";
import { getAuthState } from "store/features/authorization/authorization.selectors";
import { Rules, Exceptions } from "pages/Scheduler/components";
import { useProcessingStatus } from "hooks";

export const SchedulerOverview: React.FC = () => {
    const dispatch = useDispatch();
    const rules = useSelector(getSortableRules);
    const { isFetching, hasError } = useSelector(getSchedulerOverviewProcessingState);
    const { isAuthorized } = useSelector(getAuthState);
    useProcessingStatus(isFetching, hasError);

    useEffect(() => {
        // TODO: remove isAuthorized when authorization will be implemented
        if (isAuthorized && !rules.length) {
            dispatch(fetchSchedulerOverviewConfigs.request());
        }
    }, [dispatch, isAuthorized, rules.length]);

    return (
        <>
            <Rules />
            <Exceptions />
        </>
    );
};
